// removed by extract-text-webpack-plugin
module.exports = {"layout":"_1A-MqVtviIJg7OzX9WkHa8","container":"_2vNn7EKx2L7CE7LR7YmXO1","header":"_2egsVZfKuAA5VtejeOmZ4W","content":"_2zIXPBmM8qVNpeYLAKS0YP","breadcrumbs":"_1ERI_qFMs4dX93G0Gq3ImP","content_box":"_2W_aEcfNmbBqrLPSDosYuX","footer":"_1FIb37GAIMXF6G9cN5lOj","logo":"_4E4u3RZ633rXWLlD1Z4wH","img":"_3s7N2oNg3MXOmGkp9x9CNi","text":"_1Ovk9aysuMjzKIg10WYOEx","footer_desc":"MuJxMebY2-q9xsk4OXTvz"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/base.module.css
// module id = 827
// module chunks = 0